import React, { Component } from 'react';

import { TranslationsContext } from '@commons/translations-context';

import LanguageSelector from '@components/LanguageSelector';
import ProgressBar from '@components/ProgressBar';

import styles from '@css/layout.scss';

import {
  isAdvancedAccessibilityEnabled,
  isPageHeadSkipNavLinkRemoved
} from '@services/featureFlags';

interface PageHeadProps {
  pagerPage?: number;
  pagerPercent?: number;
  decorativeLogo?: string;
  decorativeLogoAlt?: string;
  splashLogo?: string;
  splashLogoAlt?: string;
  pageLogo?: string;
  pageLogoAlt?: string;
  languages?: unknown[];
  surveyLanguage?: string;
  surveyTitle?: string;
  useNativeDropdown?: boolean;
}

export default class PageHead extends Component<PageHeadProps> {
  static defaultProps = {
    pagerPage: 0,
    pagerPercent: 0,
    languages: []
  };

  static contextType = TranslationsContext;

  render() {
    const {
      decorativeLogo,
      decorativeLogoAlt,
      languages,
      pageLogo,
      pageLogoAlt,
      pagerPage,
      isFirstPage,
      pagerPercent,
      splashLogo,
      splashLogoAlt,
      surveyLanguage,
      surveyTitle,
      useNativeDropdown
    } = this.props;

    const isNotAPage = pagerPage === -1;
    const translations = this.context.translations;

    let urlForLogo;
    let altForLogo;
    if (isFirstPage) {
      urlForLogo = splashLogo || decorativeLogo || pageLogo;
      altForLogo = splashLogoAlt || decorativeLogoAlt || pageLogoAlt || '';
    } else {
      urlForLogo = pageLogo;
      altForLogo = pageLogoAlt || '';
    }

    // EEQ-76790 workaround.  Currently, Admin Suite does not allow setting of
    // a logo's alt text to blank.  Also, Admin Suite does not allow alt text
    // to be translated.  As such, this causes problems for things like
    // "Metro by T-Mobile", which needs to be translated to "Metro por
    // T-Mobile".  To get around this translations limitation, the img's alt
    // text would need to be set to blank so as to declare the logo as
    // "decorative" under WCAG guidelines; however, this circles us back around
    // to the first point.
    //
    // While a more proper fix is required in Admin Suite, in the meantime,
    // we will use a special setting of "===WCAG-DECORATIVE-IMAGE===" to force
    // the value to be blank.
    if (altForLogo == '===WCAG-DECORATIVE-IMAGE===') {
      altForLogo = '';
    }

    return (
      <header>
        {!(isFirstPage || isNotAPage) && <ProgressBar pagerPercent={pagerPercent} />}
        {!isPageHeadSkipNavLinkRemoved() && (
          <a className={styles.skipNav} href="#content">
            {translations.SKIP_TO_CONTENT}
          </a>
        )}
        <div className={styles.layoutContainer}>
          <div className={styles.mainHeader + ' ' + styles.clearfix}>
            <div className={styles.mainHeaderLeft}>
              {isAdvancedAccessibilityEnabled() ? (
                <h1 className={styles.invisibleTitle}>{surveyTitle}</h1>
              ) : (
                <h1 className={styles.invisibleTitle} tabIndex="0" aria-label={surveyTitle} />
              )}
              {urlForLogo && (
                <img id="pageLogo" className={styles.logo} src={urlForLogo} alt={altForLogo} />
              )}
            </div>
            <div className={styles.mainHeaderRight}>
              {isFirstPage && (
                <LanguageSelector
                  languages={languages}
                  surveyLanguage={surveyLanguage}
                  label={translations.CHOOSE_LANGUAGE}
                  useNativeDropdown={useNativeDropdown}
                />
              )}
            </div>
          </div>
        </div>
      </header>
    );
  }
}
